import React, { useRef } from "react";
// import { useNavigate } from "react-router-dom";
import CV from "../../assets/Claude Nijem CV.pdf";
import "./navbar.css";

const Navbar = () => {
	const navListRef = useRef();
	const navButtonRef = useRef();
	const navBarsIconRef = useRef();
	const navXIconRef = useRef();

	const navHamFunc = () => {
		const visibility = navListRef.current.getAttribute("data-visible");

		if (visibility === "false") {
			navListRef.current.setAttribute("data-visible", "true");
			navButtonRef.current.setAttribute("aria-expanded", "true");

			navBarsIconRef.current.classList.toggle("display-none");
			navXIconRef.current.classList.toggle("display-none");

			document.body.classList.toggle("no-scroll");
		} else if (visibility === "true") {
			navListRef.current.setAttribute("data-visible", "false");
			navButtonRef.current.setAttribute("aria-expanded", "false");

			navBarsIconRef.current.classList.toggle("display-none");
			navXIconRef.current.classList.toggle("display-none");

			document.body.classList.toggle("no-scroll");
		}
	};

	return (
		<header>
			<button
				className="mobile-nav-toggle"
				aria-controls="primary-nav"
				aria-expanded="false"
				ref={navButtonRef}
				onClick={navHamFunc}
			>
				<span className="sr-only">Menu</span>
				<div ref={navBarsIconRef}>
					<i className="fa-solid fa-bars nav-icon"></i>
				</div>
				<div ref={navXIconRef} className="display-none">
					<i className="fa-solid fa-xmark nav-icon"></i>
				</div>
			</button>
			<nav>
				<ul
					id="primary-nav"
					ref={navListRef}
					data-visible="false"
					className="flex clean-list primary-nav"
				>
					<li>
						<a href="/" className="nav-link">
							<span aria-hidden="true">00</span>Home
						</a>
					</li>
					<li>
						<a href="/about" className="nav-link">
							<span aria-hidden="true">01</span>About
						</a>
					</li>
					<li>
						<a href="/experience" className="nav-link">
							<span aria-hidden="true">02</span>Experience
						</a>
					</li>
					<li>
						<a href="/projects" className="nav-link">
							<span aria-hidden="true">03</span>Projects
						</a>
					</li>
					<li>
						<a href="/contact" className="nav-link">
							<span aria-hidden="true">04</span>Contact
						</a>
					</li>
					<li>
						<a
							href={CV}
							className="nav-link primary-btn"
							target={"_blank"}
							rel="noreferrer"
						>
							<span>
								<i className="fa-solid fa-download"></i>
							</span>{" "}
							Resume
						</a>
					</li>
				</ul>
			</nav>
		</header>
	);
};

export default Navbar;
